import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box
} from '@mui/material';

// import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import DataGridToolbar from '../../common/DataGridToolbar';
import DataGridTable from '../../common/DataGridTable';
import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import CommonRestricted from '../../common/CommonRestricted';

import { icons } from '../../common/CommonIcons';
import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useTransactions, targetTypes, actionTypes, payloadTypes } from '../../../hooks/api/useTransactions';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from '../../../hooks/useTranslations';

const ListWalletRequests = ({
    routeType
}) => {

    const { t } = useTranslations({ ns: ["common", "@transaction"] })

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list } = useTransactions({ targetType: targetTypes.request })

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.transaction.id, scopeTypes.transaction.request.id)

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = useRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            const result = await list(props)

            return {
                data: result?.data?.transactions,
                count: result?.data?.total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }
    }

    useEffect(() => {
        defineColumnsView()
    }, [])

    const defineColumnsView = () => {
        defineColumns([
            {
                name: 'transaction_no',
                header: t('transactionNo'),
                renderValue: ({ value, cellProps }) => {
                    if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`transactions/walletRequest/update/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            // {
            //     name: 'source_target', header: t('sourceTarget')
            // },
            // {
            //     name: 'destination_target', header: t('destinationTarget')
            // },
            {
                name: 'action',
                header: t('actionType'),
                renderValue: ({ value, cellProps }) => {
                    let actionType = ""

                    if (value === payloadTypes.request.transfer.action) {
                        actionType = actionTypes.request.transfer.id
                    }
                    if (value === payloadTypes.request.topup.action) {
                        actionType = actionTypes.request.topup.id
                    }
                    if (value === payloadTypes.request.withdraw.action) {
                        actionType = actionTypes.request.withdraw.id
                    }

                    return (
                        <>{actionType.toUpperCase()}</>
                    )

                }
            },
            {
                name: 'transaction_amount',
                header: t('transactionAmount'),
                renderValue: ({ value, cellProps }) => {
                    return (
                        <>{parseFloat(value).toFixed(2)}</>
                    )
                }
            },
            {
                name: 'transaction_status',
                header: t('status'),
                renderValue: ({ value, cellProps }) => {
                    return (
                        <>{value.toUpperCase()}</>
                    )
                }

            }
        ])
    }

    // const handleDelete = async () => {

    //     try {
    //         let result = await remove({ ids: selectedIds, targetType: targetTypes.transaction })

    //         promptMessage(true, result?.message)
    //         setRefreshDataGrid(currentVal => currentVal + 1)

    //     } catch (error) {
    //         promptMessage(false, error?.message)
    //     }

    // }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {
                        navigate(getRoute("transactions/walletRequest/new"));
                    }
                })
            }

            return props
        }

        // const getActionOnClick = () => {

        //     let handleFunction = null

        //     if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
        //         handleFunction = handleDelete
        //     }

        //     return handleFunction
        // }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                // actionOnClickRemove={
                //     [] // getActionOnClick()
                // }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn: false,
                    // isPermissionAllow({ functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    const getBreadcumbActionMenus = () => {

        let props = []
        return props
    }

    return (
        <Box>
            {

                getHtmlHead({ routeType, title: headTitles.walletRequests })
            }


            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("walletRequests")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("walletRequests"),
                        props: {
                            // underline: "hover",

                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}

export default ListWalletRequests;
